<template>
  <v-container class="mt-5">
    <v-row>
      <v-col cols="12">
        <v-card class="mx-auto report-card-title" max-width="70vw">
          <v-card-title>
            Relatório de emissão de fichas
          </v-card-title>
          <v-card-subtitle>
            Data:
            {{ formatDisplayDate(startDate) }} -
            {{ formatDisplayDate(endDate) }}
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-containter style="width:70vw!important;" class="mx-auto pl-5">
        <v-row no-gutters class="no-gutter">
          <v-col cols="12" md="6">
            <v-card
              class="mx-auto card-equal-height report-card-title"
              max-width="35vw"
            >
              <v-list-item>
                <v-list-item-content>
                  <div class="mb-4 card-title">
                    ATENDIMENTOS TOTAIS
                  </div>
                  <v-list-item-title class="text-h7 mb-1 card-text">
                    Atendidos
                  </v-list-item-title>
                  <v-list-item-subtitle class="card-text">{{
                    countCalled
                  }}</v-list-item-subtitle>
                  <v-list-item-title class="text-h7 mb-1 card-text">
                    Não iniciados
                  </v-list-item-title>
                  <v-list-item-subtitle class="card-text">{{
                    groupedData.length - countCalled
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar tile size="80" color="none">
                  <v-icon x-large style="font-size: 75px; color: green"
                    >mdi-account-group</v-icon
                  >
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card
              class="mx-auto card-equal-height report-card-title"
              max-width="35w"
            >
              <v-list-item>
                <v-list-item-content>
                  <div class="mb-4 card-title">
                    TEMPO MÉDIO DE ESPERA
                  </div>
                  <v-list-item-title class="text-h6 mb-1">
                    {{waitingAverage}}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar tile size="80" color="none">
                  <v-icon x-large style="font-size: 75px; color: purple"
                    >mdi-clock-time-eight-outline</v-icon
                  >
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-containter>
      <v-col cols="12">
        <v-card
          class="mx-auto card-entries"
          max-width="70vw"
          style="background: #fff; padding-bottom: 5px!important;"
        >
          <v-card-title>Atendimentos por consultório</v-card-title>
          <hr />
          <v-container>
            <v-row
              style="margin-bottom: -30px!important"
              no-gutters
              v-for="(amount, name) in groupedNames"
              :key="name"
            >
              <v-col>
                <v-card-subtitle
                  ><strong>{{ name }}</strong
                  >: {{ amount }}</v-card-subtitle
                >
              </v-col>
            </v-row>
          </v-container>
          <v-card-text> </v-card-text>
        </v-card>
      </v-col>

      <v-col v-for="(entry, index) in groupedData" :key="index" cols="12">
        <v-card class="mx-auto card-entries" max-width="70vw">
          <v-card-title class="card-title"
            >{{ entry.showTicket ? entry.type_key : "-" }} -
            {{ entry.showName ? entry.name : "-" }}</v-card-title
          >
          <hr />
          <v-card-subtitle class="card-subtitle">
            Entrou em: {{ formatDate(entry.created_at) }} <br />
            {{
              entry.history &&
              Array.isArray(entry.history) &&
              entry.history.length > 0
                ? `Esperou ${subtractDate(
                    entry.history[0].updated_at,
                    entry.created_at
                  )} até ser atendido.`
                : ""
            }}
          </v-card-subtitle>
          <v-card-text class="card-text" v-if="entry.history.length > 0">
            <v-row
              dense
              v-for="(historyEntry, historyIndex) in entry.history"
              :key="historyIndex"
            >
              <v-col cols="12"
                ><strong>Encaminhado: </strong>{{ historyEntry.name }} as
                {{ formatDate(historyEntry.updated_at) }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-else>
            <v-row>
              <v-alert class="ml-3" colored-border type="info" elevation="2">
                <small>Este cliente não teve seu atendimento iniciado.</small>
              </v-alert>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format, parseISO, addHours, isValid, differenceInMinutes } from "date-fns";

export default {
  name: "vc-history-grid",
  props: {
    reports: {
      type: Array,
      default: () => [],
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      records: this.reports,
    };
  },
  computed: {
    groupedData() {
      let result = [];
      this.records.forEach((record) => {
        let existingRecord = result.find(
          (item) => item.type_key === record.type_key
        );
        if (existingRecord) {
          existingRecord.history.push(...record.history);
        } else {
          result.push({
            type_key: record.type_key,
            created_at: record.created_at,
            name: record.name,
            showName: true,
            showTicket: true,
            history: record.history,
          });
        }
      });
      return result;
    },
    countCalled() {
      let counter = 0;
      this.groupedData.forEach((element) => {
        if (element.history.length) {
          counter++;
        }
      });
      return counter;
    },
    groupedNames() {
      let result = {};

      this.records.forEach((item) => {
        item.history.forEach((historyItem) => {
          if (Object.prototype.hasOwnProperty.call(result, historyItem.name)) {
            result[historyItem.name]++;
          } else {
            result[historyItem.name] = 1;
          }
        });
      });
      return result;
    },
   waitingAverage() {
      let totalWaitTime = 0;
      let numRecords = 0;

      this.records.forEach((item) => {
        //grant the record exist
        if (
          item.history &&
          Array.isArray(item.history) &&
          item.history.length > 0
        ) {
          const created = new Date(item.created_at);
          const resolved = new Date(item.history[0].updated_at);
          const waitTime = resolved - created;
          totalWaitTime += waitTime;
          numRecords++;        
        }
      });

      if (numRecords === 0) {
        return "Não há registro";
      }

      const averageWaitTime = totalWaitTime / numRecords;
      const hours = Math.floor(averageWaitTime / (1000 * 60 * 60));
      const minutes = Math.floor(
        (averageWaitTime % (1000 * 60 * 60)) / (1000 * 60)
      );

      const formattedAverageWaitTime = ("0" + hours).slice(-2) + "h:" + ("0" + minutes).slice(-2) + "m";

      return formattedAverageWaitTime;
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const date = parseISO(dateString);
      if (!isValid(date)) return "-";
      const adjustedDate = addHours(date, 0);
      return format(adjustedDate, "dd/MM/yyyy - HH:mm:ss");
    },
    formatDisplayDate(dateString) {
      if (!dateString) return "";
      const date = parseISO(dateString);
      if (!isValid(date)) return "-";
      return format(date, "dd/MM/yyyy");
    },
    subtractDate(dateString1, dateString2) {
      //using date-fns

      const date1 = new Date(dateString1);
      const date2 = new Date(dateString2);

      const diffMinutes = differenceInMinutes(date2, date1)
      const diffHours = Math.floor(diffMinutes / 60);
      const remainingMinutes = diffMinutes % 60;

      const formattedDiff = `${diffHours
        .toString()
        .padStart(2, "0")}h${remainingMinutes.toString().padStart(2, "0")}m`;

      return formattedDiff;
    },
  },
};
</script>

<style scoped>
v-container {
  max-width: 70vw;
}

hr {
  color: #e7e7e700;
  border-top: 1px dashed #858585;
}

.report-card-title {
  font-family: "Roboto";
  width: 80vw;
  background-color: #fff;
  border-style: solid !important;
  border-width: 1px;
  border-color: #e7e7e7;
}
.card-entries {
  font-family: "Roboto";
  width: 80vw;
  background: #fff9cc;
  border-style: solid !important;
  border-width: 1px;
  border-color: #e7e7e7;
}
v-card {
  margin-bottom: 5px;
}

.no-gutter {
  margin: 0 !important;
  padding-left: 10px;
}

.card-title,
.card-subtitle,
.card-text {
  font-family: "Roboto";
  font-size: 1rem;
}

.card-equal-height {
  display: flex;
  flex-direction: column;
  height: 150px;
}

.card-equal-height > .v-card__text {
  flex-grow: 1;
}

@media (max-width: 600px) {
  .card-title,
  .card-subtitle,
  .card-text {
    font-size: 0.75rem;
  }
}

::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #ffeaa5;
  border-radius: 20px;
}

::-webkit-scrollbar-thumb {
  background-color: #fff;
  border-radius: 20px;
  border: solid 3px #fff;
}
</style>
